import api from '../lib/api'
import assign from 'lodash.assign'

const name = 'free-radio'

export default {
  name,
  namespaced: true,
  state () {
    return {
      pageNo: 1,
      list: [],
      totalPage: 0,
      prepareLoading: true,
      bannerImage: '',
      radioCourseVo: [],
      isSubscribe: 0
    }
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    },
    setList (state, data) {
      state.list = state.list.concat(data)
    }
  },
  actions: {
    async loadMore ({ commit, state, rootState: { route } }) {
      if (!state.prepareLoading) return
      commit('set', { prepareLoading: false})
      const { data } = await api.free.getRadio(route.params.courseId, state.pageNo)()
      data.radioChapterVoList.map((val) => {
        val.title = val.name
        val.happenTime = val.publishDate
        val.duration = val.videoLength
      })
      commit('setList', data.radioChapterVoList)
      commit('set', {
        radioCourseVo: data.radioCourseVo,
        totalPage: data.total,
        pageNo: state.pageNo + 1,
        prepareLoading: true,
        isSubscribe: data.radioCourseVo.isSubscribe,
        type: data.radioCourseVo.type
      })
    },
    async subscribe ({ commit, state, rootState: { route } }) {
      let status = state.isSubscribe ? 0 : 1
      const { data } = await api.free.subscribe(status, state.type, route.params.courseId)()
      if (data === 'success') {
        commit('set', { isSubscribe: status})
      }
    }
  }
}
